// src/components/Sidebar.tsx
import React, { useEffect, useState } from "react";
import { ProjectAPI } from "../api/apiClient"; // uses fetch with Authorization
import { useUI } from "../context/UIContext";
import clsx from "clsx";
import { useAuth } from "../context/AuthContext";
import { getConnection } from "../api/signalRClient";
import { useNavigate } from "react-router-dom";

type Project = {
  projectNo: number;
  projectName: string;
  projectDescription?: string;
};

type Issue = {
  taskId: number;
  title: string;
  dueDate?: string; // ISO string
  progressPercent?: number; // 0-100
  prevProgressPercent?: number; // up to yesterday (0-100)
  isClosed?: boolean;
  taskGroupName?: string;
  hasUnread?: boolean;
};

export default function Sidebar({
  onSelect,
}: {
  onSelect?: () => void;  // ✅ NEW
}) {
  const { selectedProjectId, setSelectedProjectId,selectedProjectName,
  setSelectedProjectName, selectedIssueId, setSelectedIssueId, setViewMode, viewMode, setSelectedIssueTitle, pushUIState, setAllIssuesFilters      } =
    useUI();
  const [projects, setProjects] = useState<Project[]>([]);
  const [issuesMap, setIssuesMap] = useState<Record<number, Issue[]>>({});
  const [expandedProject, setExpandedProject] = useState<number | null>(null);
  const [loading, setLoading] = useState(false);
  const { token, logout } = useAuth();

  const navigate = useNavigate();
const userType = localStorage.getItem("userType")?.toLowerCase();

  useEffect(() => {
    if (!token) return;   // 👈 ensure login finished
    let mounted = true;
    setLoading(true);
    ProjectAPI.getAll()
      .then((data) => {
        if (!mounted) return;
        setProjects(Array.isArray(data) ? data : []);
      })
      .catch(console.error)
      .finally(() => {
        if (mounted) setLoading(false);
      });
    return () => {
      mounted = false;
    };
  }, []); // ✅ ADD token here

  // Load issues per project when expanded
  useEffect(() => {
    //!token ||
    if (!token || !expandedProject) return;
    let cancelled = false;
    ProjectAPI.getIssues(expandedProject)
      .then((data) => {
        if (cancelled) return;
        // Filter: only open OR closed today; assume API respects that, otherwise filter here
        setIssuesMap((m) => ({ ...m, [expandedProject]: Array.isArray(data) ? data : [] }));
      })
      .catch(console.error);
    return () => {
      cancelled = true;
    };
  }, [expandedProject]);

  const loadIssues = async (projectId: number) => {
  const data = await ProjectAPI.getIssues(projectId);
  setIssuesMap(m => ({ ...m, [projectId]: data ?? [] }));
};

  // Use effect for SignalR


useEffect(() => {
  if (!token || !selectedProjectId) return;

  const conn = getConnection();
  if (!conn || conn.state !== "Connected") return;

  conn.invoke("JoinProject", selectedProjectId)
    .catch(err => console.error("JoinProject failed:", err));

  conn.on("IssueUpdated", handleIssueUpdated);

  return () => conn.off("IssueUpdated", handleIssueUpdated);
}, [token, selectedProjectId]);

/*useEffect(() => {
  if (!token) return;

  let mounted = true;
  setLoading(true);

  const loadProjects = async () => {
    try {
      const data = await ProjectAPI.getAll();

      if (!mounted) return;

      let list = Array.isArray(data) ? data : [];

      // ✅ THIS IS THE FIX
    
     if (selectedProjectId) {
  // ✅ ONLY LOAD SELECTED PROJECT
  const project = data.find(p => p.projectNo === selectedProjectId);
  setProjects(project ? [project] : []);
} else {
  // ✅ LOAD ALL PROJECTS
  setProjects(Array.isArray(data) ? data : []);
}

      setProjects(list);
    } catch (err) {
      console.error(err);
    } finally {
      if (mounted) setLoading(false);
    }
  };

  loadProjects();

  return () => {
    mounted = false;
  };
}, [token, selectedProjectId]);*/ // ✅ IMPORTANT


  function pickProject(p: Project) {
    //
     pushUIState(); // ✅ ADD FIRST
    setSelectedProjectId(p.projectNo);
    setSelectedProjectName(p.projectName); // ✅ ADD THIS LINE
    setSelectedIssueId(null);
   // setViewMode("project-chat");
    //setViewMode("project-dashboard");      // ✅ 4️⃣ SHOW DASHBOARD
    setExpandedProject(p.projectNo); // auto-expand on select
    
  }

  async function pickIssue(issue: Issue, projectId: number) {
    if (!projectId) return; 
     pushUIState(); // ✅ ADD FIRST
    setSelectedProjectId(projectId);
    setSelectedIssueId(issue.taskId);
    setSelectedIssueTitle(issue.title);
    //setViewMode("issue-chat");
    // ✅ FIX: preserve Details if already in Details
    setViewMode((prev) =>
      prev === "issue-details" ? "issue-details" : "issue-chat"
    );


    await ProjectAPI.markIssueRead(projectId, issue.taskId);
   
  }

  function handleIssueUpdated() {
  if (expandedProject) {
    ProjectAPI.getIssues(expandedProject)
      .then(data => setIssuesMap(prev => ({ ...prev, [expandedProject]: data })))
      .catch(console.error);
  }
}

  // helper: color for due state
  const dueColor = (due?: string) => {
    if (!due) return "text-gray-500";
    const d = new Date(due);
    const today = new Date();
    // zero time part for comparison
    today.setHours(0, 0, 0, 0);
    const diff = Math.floor((d.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    if (diff < 0) return "text-red-600"; // overdue
    if (diff === 0) return "text-orange-500"; // due today
    return "text-green-600"; // upcoming
  };

  return (
    //p-3 h-full
    <div className="p-3 h-full flex flex-col"> 
    
      <div className="p-4 flex items-center justify-between border-b bg-white">
        <div className="flex items-center gap-2">
          <img src="/icon.png" alt="Baevr Logo" className="w-7 h-7 rounded-lg" />
          <span className="font-bold text-lg">Baevr Live</span>
        </div>
{/* NSite Button */}
<button
  onClick={() =>
    window.open(
      "http://nsite.baevr.com/home",
      "_blank"
    )
  }
  className="bg-green-600 hover:bg-green-700 text-white text-sm px-3 py-1 rounded-lg transition"
>
  NSite
</button>
        

         {userType === "superadmin" && (
    <button
      onClick={() => navigate("/add-user")}
      className="text-sm text-blue-600 hover:underline"
    >
      Super
      admin
    </button>
  )}
        <button
          onClick={logout}   // ✅ NEW
          className="text-sm text-red-600 hover:underline"
        >
          Logout
        </button>
      </div>
      {loading && <div className="px-3 text-sm text-gray-500">Loading projects...</div>}
      {/*p-3 h-full flex flex-col overflow-y-auto */}
      
      <div className="p-3 flex-1 flex flex-col overflow-y-auto">
        
        <div className="space-y-2 flex-1 pr-2">
          {projects.map((p) => {
            const isSelected = selectedProjectId === p.projectNo;
            const issues = issuesMap[p.projectNo] ?? [];
            const expanded = expandedProject === p.projectNo;
            return (
              <div key={p.projectNo} className="border rounded-lg bg-blue-50 border-blue-200">
                <div
                  className={clsx(
                    "flex items-center justify-between px-3 py-2 cursor-pointer transition-colors",
                    isSelected ? "bg-blue-100 border-blue-300" : "hover:bg-blue-100"
                  )}
                  onClick={() => {
                      pickProject(p);
                      onSelect?.();   // ✅ NEW — notify AppLayout
                    }}
                >
                  <div>
                    <div className="font-semibold text-base">{p.projectName}</div>
                    <div className="text-xs text-gray-500">{p.projectDescription}</div>
                  </div>

                  <div className="flex items-center gap-2">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setExpandedProject((cur) => (cur === p.projectNo ? null : p.projectNo));
                      }}
                      className="text-sm px-2 py-1 border rounded text-gray-600"
                      title="Expand issues"
                    >
                      {expanded ? "▾" : "▸"}
                    </button>

                    
                  </div>
                </div>

                {expanded && (
                  <div className="px-3 py-2 border-t bg-gray-50">
                    {issues.length === 0 ? (
                      <div className="text-sm text-gray-500">No open issues</div>
                    ) : (
                      <div className="space-y-3">
                        {issues.map((iss) => {
                          // derive today's progress vs prev progress if available
                          const prev = iss.prevProgressPercent ?? Math.max(0, (iss.progressPercent ?? 0) - 5);
                          const total = iss.progressPercent ?? 0;
                          const today = Math.max(0, total - prev);
                          const prevWidth = Math.max(0, Math.min(100, prev));
                          const todayWidth = Math.max(0, Math.min(100, today));
                          return (
                            <div key={iss.taskId} 
                              className={clsx(
                              "cursor-pointer px-2 py-2 rounded-md transition",
                                selectedIssueId === iss.taskId
                                ? "bg-gray-300 border-l-4 border-blue-600"
                                : "bg-white hover:bg-gray-100"
                                )}
                              onClick={() => {
                                pickIssue(iss, p.projectNo);
                                onSelect?.();  // ✅ NEW
                              }}
                            >
                              <div className="flex items-start justify-between">
                                <div>
                                  <div className={`font-medium ${iss.hasUnread ? "text-blue-700 font-bold" : "text-gray-700"}`}>
                                    {iss.title}
                                    </div>
                                  {iss.taskGroupName && (
                                    <div className="text-xs text-gray-500 mt-0.5">
                                      {iss.taskGroupName}
                                    </div>
                                  )}
                                  <div className="text-xs">
                                    <span className={dueColor(iss.dueDate)}>
                                      {iss.dueDate ? new Date(iss.dueDate).toLocaleDateString() : "No date"}
                                    </span>
                                    <span className="ml-2 text-gray-500">
                                      • {iss.progressPercent ?? 0}% done
                                    </span>
                                  </div>
                                  <div className="mt-2 h-2 w-full bg-gray-200 rounded overflow-hidden">
                                    <div
                                      style={{ width: `${prevWidth}%` }}
                                      className="h-2"
                                    >
                                      <div
                                        style={{ width: "100%" }}
                                        className="h-2 bg-green-800"
                                      />
                                    </div>
                                    {todayWidth > 0 && (
                                      <div
                                        style={{
                                          width: `${todayWidth}%`,
                                          marginLeft: `${prevWidth}%`,
                                          transform: `translateX(-${prevWidth}% )`,
                                        }}
                                        className="relative h-2"
                                      >
                                        <div
                                          style={{ width: "100%" }}
                                          className="h-2 bg-green-300 absolute left-0 top-0"
                                        />
                                      </div>
                                    )}
                                  </div>
                                </div>
                            
                              </div>
                            </div>
                          );
                        })}

                       
                        {/* ============================= */}
                    {/* ✅ ADD THIS BLOCK (GANTT) */}
                    {/* ============================= */}
                  {/* <button
                      onClick={(e) => {
                        e.stopPropagation();
                        pushUIState();
                        setSelectedProjectId(p.projectNo);
                        setSelectedProjectName(p.projectName);
                        setSelectedIssueId(null);
                        setSelectedIssueTitle(null);
                        setViewMode("project-gantt"); // ⭐ STEP 5.2
                        onSelect?.();
                      }}
                      className="mt-2 w-full text-center text-sm text-blue-600 hover:underline"
                    >
                      Gantt
                    </button>*/}
                    {/* ============================= */}
                    {/* ✅ END GANTT ADDITION */}
                    {/* ============================= */}

                       {/* <button
                          onClick={(e) => {
                            e.stopPropagation();
                            //
                            pushUIState(); // ✅ ADD FIRST
                            setSelectedProjectId(p.projectNo);
                            setSelectedProjectName(p.projectName); // ✅ ADD THIS LINE
                            
                            setSelectedIssueId(null);       // Clear selected issue
                            setSelectedIssueTitle(null);    // Clear issue title
                            
                           
                            setViewMode("all-issues");   // ⭐ tells main view to show AllIssues.tsx
                           
                            onSelect?.();
                          }}
                          className="mt-3 w-full text-center text-sm text-blue-600 hover:underline"
                        >
                          More...
                        </button>*/}
                      </div>
                      
                    )}

                    <button
                          onClick={(e) => {
                            e.stopPropagation();
                            //
                            pushUIState(); // ✅ ADD FIRST
                            setSelectedProjectId(p.projectNo);
                            setSelectedProjectName(p.projectName); // ✅ ADD THIS LINE
                            
                            setSelectedIssueId(null);       // Clear selected issue
                            setSelectedIssueTitle(null);    // Clear issue title
                            
                           
                               // ✅ THIS IS THE FIX
    setAllIssuesFilters({
      status: "",
      taskGroup: "",
      fromDue: "",
      toDue: "",
    });



                            setViewMode("all-issues");   // ⭐ tells main view to show AllIssues.tsx
                           
                            onSelect?.();
                          }}
                          className="mt-3 w-full text-center text-sm text-blue-600 hover:underline"
                        >
                          More...
                        </button>
                  </div>
                )}
              </div>
            );
          })}


        {/* {localStorage.getItem("role")?.toLowerCase() === "superadmin" && (
  <div
    onClick={() => {
      pushUIState();
      setSelectedProjectId(null);
      setSelectedIssueId(null);
      setViewMode("superadmin");
      onSelect?.();
    }}
    className="bg-white border rounded-lg p-3 mt-3 shadow cursor-pointer hover:bg-gray-50"
  >
    <div className="font-semibold text-blue-600">
      Super Admin Dashboard
    </div>
    <div className="text-sm text-gray-500">
      Manage users & projects
    </div>
  </div>
)}*/}
        </div>
      </div>

      {/* <div className="mt-4 p-3 border-t">
        <button
          onClick={() => {
            // new issue (placeholder)
            alert("Create new issue - feature coming");
          }}
          className="w-full py-2 bg-blue-600 text-white rounded"
        >
          + New Issue
        </button>

        <div className="mt-3 flex flex-col gap-2 text-sm">
          <button className="text-left text-gray-600 hover:underline">Reports</button>
          <button className="text-left text-gray-600 hover:underline">Cross-project dashboard</button>
        </div>
      </div> */}
    </div>
  );
}
